import React, {useCallback} from 'react'
import {INavNotification} from '@api/user/account/notification/getNotification'
import PostOfficialNotificationItem from '@feature/account/components/notifications/NotificationListItem/PostOfficialNotificationItem'
import PortfolioLossNotificationItem from '@feature/account/components/notifications/NotificationListItem/PortfolioLossNotificationItem'
import PortfolioGainNotificationItem from '@feature/account/components/notifications/NotificationListItem/PortfolioGainNotificationItem'
import FollowNotificationItem from '@feature/account/components/notifications/NotificationListItem/FollowNotificationItem'
import PostNotificationItem from '@feature/account/components/notifications/NotificationListItem/PostNotificationItem'
import CommentNotificationItem from '@feature/account/components/notifications/NotificationListItem/CommentNotificationItem'
import ReplyCommentNotificationItem from '@feature/account/components/notifications/NotificationListItem/ReplyCommentNotificationItem'
import LikePostNotificationItem from '@feature/account/components/notifications/NotificationListItem/LikePostNotificationItem'
import LikeCommentNotificationItem from '@feature/account/components/notifications/NotificationListItem/LikeCommentNotificationItem'
import BotCreateNotificationItem from '@feature/account/components/notifications/NotificationListItem/BotCreateNotificationItem'
import BotStopNotificationItem from '@feature/account/components/notifications/NotificationListItem/BotStopNotificationItem'
import BotError6003NotificationItem from '@feature/account/components/notifications/NotificationListItem/BotError6003NotificationItem'
import BotError6011NotificationItem from '@feature/account/components/notifications/NotificationListItem/BotError6011NotificationItem'
import CopyGainNotificationItem from '@feature/account/components/notifications/NotificationListItem/CopyGainNotificationItem'
import CopyLossNotificationItem from '@feature/account/components/notifications/NotificationListItem/CopyLossNotificationItem'
import CopierNotificationItem from '@feature/account/components/notifications/NotificationListItem/CopierNotificationItem'
import StopLossNotificationItem from '@feature/account/components/notifications/NotificationListItem/StopLossNotificationItem'
import TakeProfitNotificationItem from '@feature/account/components/notifications/NotificationListItem/TakeProfitNotificationItem'
import ActiveStopLossNotificationItem from '@feature/account/components/notifications/NotificationListItem/ActiveStopLossNotificationItem'
import ActiveTakeProfitNotificationItem from '@feature/account/components/notifications/NotificationListItem/ActiveTakeProfitNotificationItem'
import WithdrawProgressingNotificationItem from '@feature/account/components/notifications/NotificationListItem/WithdrawProgressingNotificationItem'
import WithdrawConfirmedNotificationItem from '@feature/account/components/notifications/NotificationListItem/WithdrawConfirmedNotificationItem'
import WithdrawCreatedNotificationItem from '@feature/account/components/notifications/NotificationListItem/WithdrawCreatedNotificationItem'
import FeeReceiptNotificationItem from '@feature/account/components/notifications/NotificationListItem/FeeReceiptNotificationItem'
import FeePayoutNotificationItem from '@feature/account/components/notifications/NotificationListItem/FeePayoutNotificationItem'
import InvoiceNewNotificationItem from '@feature/account/components/notifications/NotificationListItem/InvoiceNewNotificationItem'
import InvoiceMissingNotificationItem from '@feature/account/components/notifications/NotificationListItem/InvoiceMissingNotificationItem'
import InvoiceReminderNotificationItem from '@feature/account/components/notifications/NotificationListItem/InvoiceReminderNotificationItem'
import InvoiceReminderDayNotificationItem from '@feature/account/components/notifications/NotificationListItem/InvoiceReminderDayNotificationItem'
import InvoiceReminderHourNotificationItem from '@feature/account/components/notifications/NotificationListItem/InvoiceReminderHourNotificationItem'
import LeagueStartNotificationItem from '@feature/account/components/notifications/NotificationListItem/LeagueStartNotificationItem'
import LeagueEndNotificationItem from '@feature/account/components/notifications/NotificationListItem/LeagueEndNotificationItem'
import RankNotificationItem from '@feature/account/components/notifications/NotificationListItem/RankNotificationItem'
import EventNotificationItem from '@feature/account/components/notifications/NotificationListItem/EventNotificationItem'
import KeyFailedNotificationItem from '@feature/account/components/notifications/NotificationListItem/KeyFailedNotificationItem'
import AlertPriceNotificationItem from '@feature/account/components/notifications/NotificationListItem/AlertPriceNotiifcationItem'
import OrderNotificationItem from '@feature/account/components/notifications/NotificationListItem/OrderNotiifcationItem'
import AnnounceNotificationItem from '@feature/account/components/notifications/NotificationListItem/AnnounceNotificationItem'
import ProStartSubscribingNotificationItem from '@feature/account/components/notifications/NotificationListItem/ProStartSubscribingNotificationItem'
import ProReminderNotificationItem from '@feature/account/components/notifications/NotificationListItem/ProReminderNotificationItem'
import ProExpiredNotificationItem from '@feature/account/components/notifications/NotificationListItem/ProExpiredNotificationItem'
import ProExpiredLeaderNotificationItem from '@feature/account/components/notifications/NotificationListItem/ProExpiredLeaderNotificationItem'
import ProReminderLeaderNotificationItem from '@feature/account/components/notifications/NotificationListItem/ProReminderLeaderNotificationItem'
import InvoiceReminderNewNotificationItem from '@feature/account/components/notifications/NotificationListItem/InvoiceReminderNewNotificationItem'
import InvoiceStoppedNotificationItem from '@feature/account/components/notifications/NotificationListItem/InvoiceStoppedNotificationItem'
import InvoiceSubmittedNotificationItem from '@feature/account/components/notifications/NotificationListItem/InvoiceSubmittedNotificationItem'
import InvoiceSubmittedRestartNotificationItem from '@feature/account/components/notifications/NotificationListItem/InvoiceSubmittedRestartNotificationItem'
import InvoiceSubmittedAutoNotificationItem from '@feature/account/components/notifications/NotificationListItem/InvoiceSubmittedAutoNotificationItem'
import InvoiceSubmittedPartialNotificationItem from '@feature/account/components/notifications/NotificationListItem/InvoiceSubmittedPartialNotificationItem'
import DepositNotificationItem from '@feature/account/components/notifications/NotificationListItem/DepositNotificationItem'
import PointNotificationItem from '@feature/account/components/notifications/NotificationListItem/PointNotificationItem'
import InvoiceExpectedReminderNotificationItem from '@feature/account/components/notifications/NotificationListItem/InvoiceExpectedReminderNotificationItem'
import InvoiceIncomingNotificationItem from '@feature/account/components/notifications/NotificationListItem/InvoiceIncomingNotificationItem'

interface IProps {
    data?: INavNotification
}

const NavNotificationListItem = ({data}: IProps) => {
    const renderContents = useCallback(() => {
        switch (data?.type) {
            case 'post.official':
                return <PostOfficialNotificationItem {...data} />
            case 'portfolio.loss':
                return <PortfolioLossNotificationItem {...data} />
            case 'portfolio.gain':
                return <PortfolioGainNotificationItem {...data} />
            case 'follow':
                return <FollowNotificationItem {...data} />
            case 'post':
                return <PostNotificationItem {...data} />
            case 'comment':
                return <CommentNotificationItem {...data} />
            case 'reply.comment':
                return <ReplyCommentNotificationItem {...data} />
            case 'like.post':
                return <LikePostNotificationItem {...data} />
            case 'like.comment':
                return <LikeCommentNotificationItem {...data} />
            case 'bot.create':
                return <BotCreateNotificationItem {...data} />
            case 'bot.stop':
                return <BotStopNotificationItem {...data} />
            case 'bot.error.6003':
                return <BotError6003NotificationItem {...data} />
            case 'bot.error.6011':
                return <BotError6011NotificationItem {...data} />
            case 'copy.gain':
                return <CopyGainNotificationItem {...data} />
            case 'copy.loss':
                return <CopyLossNotificationItem {...data} />
            case 'copier':
                return <CopierNotificationItem {...data} />
            case 'stop.loss':
                return <StopLossNotificationItem {...data} />
            case 'take.profit':
                return <TakeProfitNotificationItem {...data} />
            case 'activate.stop.loss':
                return <ActiveStopLossNotificationItem {...data} />
            case 'activate.take.profit':
                return <ActiveTakeProfitNotificationItem {...data} />
            case 'deposit':
                return <DepositNotificationItem {...data} />
            case 'withdraw.processing':
                return <WithdrawProgressingNotificationItem {...data} />
            case 'withdraw.confirmed':
                return <WithdrawConfirmedNotificationItem {...data} />
            case 'withdraw.created':
                return <WithdrawCreatedNotificationItem {...data} />
            case 'fee.receipt':
                return <FeeReceiptNotificationItem {...data} />
            case 'fee.payout':
                return <FeePayoutNotificationItem {...data} />
            case 'invoice.new':
                return <InvoiceNewNotificationItem {...data} />
            case 'invoice.missing':
                return <InvoiceMissingNotificationItem {...data} />
            case 'invoice.reminder':
                return <InvoiceReminderNotificationItem {...data} />
            case 'invoice.reminder.day':
                return <InvoiceReminderDayNotificationItem {...data} />
            case 'invoice.reminder.hour':
                return <InvoiceReminderHourNotificationItem {...data} />
            case 'league.start':
                return <LeagueStartNotificationItem {...data} />
            case 'league.end':
                return <LeagueEndNotificationItem {...data} />
            case 'rank':
                return <RankNotificationItem {...data} />
            case 'events':
                return <EventNotificationItem {...data} />
            case 'key.failed':
                return <KeyFailedNotificationItem {...data} />
            case 'alert.price':
                return <AlertPriceNotificationItem {...data} />
            case 'orders':
                return <OrderNotificationItem {...data} />
            case 'announce':
                return <AnnounceNotificationItem {...data} />
            case 'pro.subscribing':
                return <ProStartSubscribingNotificationItem {...data} />
            case 'pro.reminder':
                return <ProReminderNotificationItem {...data} />
            case 'pro.expired':
                return <ProExpiredNotificationItem {...data} />
            case 'pro.reminder.trading':
                return <ProReminderLeaderNotificationItem {...data} />
            case 'pro.expired.trading':
                return <ProExpiredLeaderNotificationItem {...data} />
            case 'invoice.reminder.new':
                return <InvoiceReminderNewNotificationItem {...data} />
            case 'invoice.stopped':
                return <InvoiceStoppedNotificationItem {...data} />
            case 'invoice.submitted':
                return <InvoiceSubmittedNotificationItem {...data} />
            case 'invoice.submitted.restart':
                return <InvoiceSubmittedRestartNotificationItem {...data} />
            case 'invoice.submitted.auto':
                return <InvoiceSubmittedAutoNotificationItem {...data} />
            case 'invoice.submitted.partial':
                return <InvoiceSubmittedPartialNotificationItem {...data} />
            case 'invoice.expected.reminder':
                return <InvoiceExpectedReminderNotificationItem {...data} />
            case 'point.daily':
                return <PointNotificationItem {...data} />
            case 'invoice.expected.reminder':
                return <InvoiceIncomingNotificationItem {...data} />
            default:
                return <></>
        }
    }, [data])

    return <>{renderContents()}</>
}

export default NavNotificationListItem
